import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../resources/logo/mm_logo_bland.png';
const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const isQuotePage = location.pathname === '/quote';

    const closeMenu = () => setIsOpen(false);

    return (
        <header className="navbar">
            <div className="container navbar__inner">
                <div className="navbar__left">
                    <Link to="/" className="navbar__brand" onClick={closeMenu}>
                        <img
                            src={logo}
                            alt="The M&M Services logo"
                            className="navbar__logo"
                        />
                        <span className="navbar__title">THE M&amp;M SERVICES</span>
                    </Link>
                </div>

                <button
                    className="navbar__toggle"
                    onClick={() => setIsOpen((prev) => !prev)}
                    aria-label="Toggle navigation menu"
                >
                    <span className="navbar__toggle-bar" />
                    <span className="navbar__toggle-bar" />
                </button>

                <nav className={`navbar__nav ${isOpen ? 'navbar__nav--open' : ''}`}>
                    <ul>
                        <li>
                            <Link to="/" className="navbar__link" onClick={closeMenu}>
                                Home
                            </Link>
                        </li>
                        <li>
                            {isQuotePage ? (
                                <Link to="/" className="navbar__link" onClick={closeMenu}>
                                    Services
                                </Link>
                            ) : (
                                <a href="#services" className="navbar__link" onClick={closeMenu}>
                                    Services
                                </a>
                            )}
                        </li>
                        <li>
                            {isQuotePage ? (
                                <Link to="/" className="navbar__link" onClick={closeMenu}>
                                    Why Us
                                </Link>
                            ) : (
                                <a href="#why-us" className="navbar__link" onClick={closeMenu}>
                                    Why Us
                                </a>
                            )}
                        </li>
                        <li>
                            {isQuotePage ? (
                                <Link to="/" className="navbar__link" onClick={closeMenu}>
                                    Service Areas
                                </Link>
                            ) : (
                                <a href="#areas" className="navbar__link" onClick={closeMenu}>
                                    Service Areas
                                </a>
                            )}
                        </li>
                        <li>
                            <Link
                                to="/quote"
                                className="btn btn-primary navbar__quote-btn"
                                onClick={closeMenu}
                            >
                                Get a Quote
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Navbar;
